<div class="bloco-item" [ngClass]="{'bloco-unico' : !exibir}">
  <h3 class="uppercase">Foto da Entrega</h3>
  <hr>
  <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoadingStreetViewThumb">
  </mat-progress-bar>
  <div *ngIf="!this.entregaUrl" style="min-height: 100px" class="d-flex justify-content-center align-items-center">
    <strong [hidden]="isLoadingStreetViewThumb">Não há informação a ser exibida!</strong>
    <strong [hidden]="!isLoadingStreetViewThumb">Aguarde...</strong>
  </div>
  <div *ngIf="this.entregaUrl" class="comp-foto">
    <a [href]="'https://www.google.com.br/maps/place/'+detalheStreetView" target="_blank"><img [src]="entregaUrl"></a>
  </div>
  <div style="text-align: center">
    <a style="color: #28a745 !important;" [href]="'https://www.google.com.br/maps/place/'+detalheStreetView"
      target="_blank">Visualizar no Google Maps <i class="fas fa-street-view"></i></a>
  </div>
</div>
